
export default {
  props: {
    additionalItems: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    items() {
      return [
        {
          name: this.$t('breadcrumb.home'),
          link: '/',
        },
        ...this.$props.additionalItems,
      ]
    },
  },
}
